import { useEffect, useState } from "react";
import { API } from "./api";

export default function ApplicationDetail({ app, setSelectedEnv }) {
  const [envCounts, setEnvCounts] = useState({});

  useEffect(() => {
    API.get("/apps").then((res) => {
      const filtered = res.data.filter(a => a.app_name === app);

      const counts = {};
      filtered.forEach((a) => {
        counts[a.environment] = (counts[a.environment] || 0) + 1;
      });

      setEnvCounts(counts);
    });
  }, [app]);

  return (
    <div>
      <h2>{app} - Environments</h2>

      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
        {Object.keys(envCounts).map((env) => (
          <div
            key={env}
            onClick={() => setSelectedEnv(env)}
            style={{
              padding: 20,
              borderRadius: 12,
              cursor: "pointer",
              minWidth: 200,
              color: "white",
              background: "linear-gradient(135deg, #10b981, #1e293b)"
            }}
          >
            <h3>{env}</h3>
            <p>{envCounts[env]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
